
import { inject } from '@angular/core';
import { UrlShortenerService } from '@ipensii/auth/data-access-auth';
import { Subscription } from 'rxjs';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '@ipensii/shared/data-access-shared';
import { urlQueryParamMatcher } from '@ipensii/shared/util-shared';



export const smsRedirectGuard: (route: ActivatedRouteSnapshot) => (boolean | Subscription) = (route) => {
  const urlShortenerService = inject(UrlShortenerService);
  const authService = inject(AuthService);
  const urlShortenerId = route.params['urlShortenerId'];
  if (!urlShortenerId) {
    console.log("No urlShortenerId provided");
    return false;
  }
  return urlShortenerService.redirectFormShortSmsUrlToActualUrl({ urlShortenerUuid: urlShortenerId}).subscribe(
    (resp) => {
      if(resp.url != null) {
        const token = resp.url?.match(urlQueryParamMatcher('token'));
        if(token){
          authService.authToken = token[0];
          window.location.href = resp.url
        }
      }
    },
    error => {
        console.log(error)
        return false;
    }
  );
}
